import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import DataGraph from './components/DataGraph';
import PrivilegedData from './components/PrivilegedData';
import PrivateRoute from './components/PrivateRoute';
import { useAuth } from './hooks/useAuth';
import CreateSuperUser from './pages/CreateSuperUser';
import AuthenticateSuperUser from './pages/AuthenticateSuperUser';
import Header from './components/Header';
import Footer from './components/Footer';
import Calendar from './pages/Calendar';
import FinancialDashboard from './components/FinancialDashboard';

function App() {
  const user = useAuth();

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/graph"
          element={
            <PrivateRoute>
              <DataGraph />
            </PrivateRoute>
          }
        />
        <Route
          path="/privileged-data"
          element={
            <PrivateRoute>
              <PrivilegedData />
            </PrivateRoute>
          }
        />
        {process.env.NODE_ENV === 'development' && (
          <Route
            path="/create-super-user"
            element={
              <PrivateRoute>
                <CreateSuperUser />
              </PrivateRoute>
            }
          />
        )}
        {process.env.NODE_ENV === 'development' && (
          <Route
            path="/authenticate-super-user"
            element={
              <PrivateRoute>
                <AuthenticateSuperUser />
              </PrivateRoute>
            }
          />
        )}
        <Route path="/calendar" element={<PrivateRoute><Calendar /></PrivateRoute>} />
        <Route
          path="/financial"
          element={
            <PrivateRoute>
              <FinancialDashboard />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
